// Reading gestures pause follow; deliberately scrolling down to the end resumes it.
class ScrollFollow {
  constructor() { this.following = true; this.expectedTop = 0; this.unread = false; this.geometry = null; }
  pause() { const changed = this.following; this.following = false; return changed; }
  measure(box) {
    if (box && Number.isFinite(box.scrollHeight) && Number.isFinite(box.clientHeight)) {
      this.geometry = { height: box.scrollHeight, client: box.clientHeight };
    }
  }
  resume(top = this.expectedTop, box) { this.following = true; this.expectedTop = top; this.unread = false; this.geometry = null; this.measure(box); }
  wrote(top, box) { this.expectedTop = top; this.measure(box); }
  scrolled(top, box) {
    const previous = this.geometry; this.measure(box);
    const resized = previous && this.geometry && (previous.height !== this.geometry.height || previous.client !== this.geometry.client);
    if (!this.following) {
      const movingDown = top > this.expectedTop + .5;
      this.expectedTop = top;
      // Layout clamps are not a user's decision to return to live output.
      if (movingDown && box && box.scrollHeight - box.clientHeight - top <= 8) {
        this.resume(top, box); return true;
      }
      return false;
    }
    // Removing a skeleton, resizing the composer or loading a widget can clamp
    // scrollTop without a gesture. Rebase on the actual geometry in that case.
    // Explicit wheel/touch/pointer/key pauses remain authoritative.
    if (resized) {
      this.expectedTop = top; return false;
    }
    if (Math.abs(top - this.expectedTop) <= 2) return false;
    this.expectedTop = top;
    return this.pause();
  }
  received() {
    if (this.following || this.unread) return false;
    this.unread = true; return true;
  }
}
// Frame-rate independent, critically damped camera. Both position and velocity
// remain continuous when another line or a large component changes the target.
class FollowMotion {
  constructor(top) { this.position = top; this.velocity = 0; this.time = null; }
  step(target, now) {
    const dt = this.time === null ? 1 / 60 : Math.min(.05, Math.max(0, now - this.time) / 1000);
    this.time = now;
    const omega = 18, offset = this.position - target, term = this.velocity + omega * offset, decay = Math.exp(-omega * dt);
    this.position = target + (offset + term * dt) * decay;
    this.velocity = (this.velocity - omega * term * dt) * decay;
    if (Math.abs(target - this.position) < .5 && Math.abs(this.velocity) < 3) { this.position = target; this.velocity = 0; }
    return this.position;
  }
}
function isReadingKey(key) { return ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(key); }
module.exports = { ScrollFollow, FollowMotion, isReadingKey };
